import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const blogPosts = [
  {
    title: 'Ultimate Guide to Marine Fuel Efficiency',
    description: 'Learn how to maximize your boat\'s fuel efficiency with our comprehensive guide. Discover key factors affecting fuel consumption and practical tips for better performance.',
    path: '/blog/marine-fuel-efficiency',
    image: 'https://placehold.co/600x400/png?text=Marine+Fuel+Efficiency',
    date: 'March 15, 2024',
    readTime: '8 min read'
  },
  {
    title: 'How to Winterize Your Boat Engine',
    description: 'A complete guide to properly winterizing your boat engine. Protect your investment and ensure smooth operation come spring with these essential steps.',
    path: '/blog/winterize-boat-engine',
    image: 'https://placehold.co/600x400/png?text=Winterize+Boat+Engine',
    date: 'March 12, 2024',
    readTime: '10 min read'
  },
  {
    title: 'Understanding Ethanol in Marine Fuel',
    description: 'Everything you need to know about ethanol in marine fuel, its effects on your engine, and how to protect your boat from ethanol-related issues.',
    path: '/blog/ethanol-in-marine-fuel',
    image: 'https://placehold.co/600x400/png?text=Ethanol+in+Marine+Fuel',
    date: 'March 8, 2024',
    readTime: '7 min read'
  },
  {
    title: 'Preventing Carbon Deposits in Marine Engines',
    description: 'Learn about the causes of carbon deposits in marine engines, their impact on performance, and effective prevention strategies.',
    path: '/blog/carbon-deposits-marine-engine',
    image: 'https://placehold.co/600x400/png?text=Carbon+Deposits',
    date: 'March 5, 2024',
    readTime: '6 min read'
  },
  {
    title: 'Marine Fuel Contamination: Signs and Solutions',
    description: 'Identify the signs of fuel contamination in your marine engine and discover effective solutions to prevent and treat this common issue.',
    path: '/blog/marine-fuel-contamination',
    image: 'https://placehold.co/600x400/png?text=Fuel+Contamination',
    date: 'March 1, 2024',
    readTime: '9 min read'
  },
  {
    title: 'Maximizing Marine Engine Performance',
    description: 'Expert tips and techniques for optimizing your marine engine\'s performance. Learn about maintenance, fuel quality, and performance-enhancing additives.',
    path: '/blog/marine-engine-performance',
    image: 'https://placehold.co/600x400/png?text=Engine+Performance',
    date: 'February 25, 2024',
    readTime: '8 min read'
  }
];

export default function BlogIndex() {
  const siteUrl = 'https://marinefuelboost.com';
  const pageTitle = 'Marine Fuel Blog - Expert Tips & Guides | Marine Fuel Boost';
  const pageDescription = 'Discover expert advice on marine engine maintenance, fuel efficiency, and performance optimization. Read our latest articles and guides for boat owners.';

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={`${siteUrl}/blog`} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={`${siteUrl}/blog`} />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <header className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Marine Fuel Blog
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Expert insights and guides to help you maintain your marine engine, improve fuel efficiency, and maximize performance on the water.
          </p>
        </header>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {blogPosts.map((post) => (
            <article
              key={post.path}
              className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
            >
              <Link to={post.path} className="block">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <div className="flex items-center text-sm text-gray-500 mb-2">
                    <time>{post.date}</time>
                    <span className="mx-2">•</span>
                    <span>{post.readTime}</span>
                  </div>
                  <h2 className="text-xl font-semibold text-gray-900 mb-2">
                    {post.title}
                  </h2>
                  <p className="text-gray-600">
                    {post.description}
                  </p>
                  <div className="mt-4 text-blue-600 hover:text-blue-700 font-medium">
                    Read more →
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </>
  );
} 